<template>
	<div class="shizheng list-wrapper" v-lazy-container="{ selector: 'img' }">
		<div class="top-pannel">
			<div class="tp-item" @click="handleCategoryClick(index)"
			:class="{active: activeCategory==index}" v-for="(c,index) in categories" :key="c.title">{{c.title}}</div>
		</div>
		<div v-for="c in categories" :key="c.title" class="category" :class="{'daoyitai-catagory': c.title == '导医台'}">
			<div class="list-title daoyitai-title" v-if="c.title == '导医台'">{{c.title}}</div>
			<div class="list-title" v-else>{{c.title}}</div>
			<div class="item-list daoyitai" v-if="c.title == '导医台'">
				<div class="item-wrapper" v-for="item in c.content" :key="item.id">
					<div class="item" >
						<a :href="item.url" target="_blank">
							<img :data-src="item.icon" :alt="item.title" class="logo">
							<div class="name">{{item.title}}</div>
						</a>
					</div>
				</div>
				<!-- <div class="item-wrapper" v-for="item in c.content" :key="item.id">
					<div class="item" >
						<a :href="item.url" target="_blank">
							<img :data-src="item.icon" :alt="item.title" class="logo">
							<div class="name">{{item.title}}</div>
						</a>
					</div>
				</div>
				<div class="item-wrapper" v-for="item in c.content" :key="item.id">
					<div class="item" >
						<a :href="item.url" target="_blank">
							<img :data-src="item.icon" :alt="item.title" class="logo">
							<div class="name">{{item.title}}</div>
						</a>
					</div>
				</div>
				<div class="item-wrapper" v-for="item in c.content" :key="item.id">
					<div class="item" >
						<a :href="item.url" target="_blank">
							<img :data-src="item.icon" :alt="item.title" class="logo">
							<div class="name">{{item.title}}</div>
						</a>
					</div>
				</div>
				<div class="item-wrapper" v-for="item in c.content" :key="item.id">
					<div class="item" >
						<a :href="item.url" target="_blank">
							<img :data-src="item.icon" :alt="item.title" class="logo">
							<div class="name">{{item.title}}</div>
						</a>
					</div>
				</div> -->
			</div>
			<div class="item-list" v-else>
				<div class="item" v-for="item in c.content" :key="item.id">
					<a :href="item.url" target="_blank" @click="handleClicked(item.id)">
						<img :data-src="item.icon" :alt="item.title" class="logo">
						<div class="name">{{item.title}}</div>
					</a>
				</div>
			</div>
		</div>
		<div>
			<loading v-show="loading">
				<span class="more-text">正在加载</span>
			</loading>
		</div>
	</div>
	
</template>
<script>
	import axios from 'axios'
	import Loading from '../components/Loading'
	import smoothscroll from 'smoothscroll-polyfill';
	import {throttle} from 'lodash'
	let scrollLock = false
	let timeout 

	export default {
		data(){
			return {
				loading: false,
				list: [],
				categories: [],
				activeCategory: 0,
			}
		},
		props: ['type'],
		components: {
			Loading
		},
		created(){
			console.log(throttle)
			const throttled = throttle(()=>{
				if(scrollLock) return
				const scrollTop = document.documentElement.scrollTop
				
				for(let i=0;i<this.categories.length;i++) {
					// console.log(scrollTop,this.categories[i].offsetTop,this.categories[i+1].offsetTop)
					if(this.categories[i].offsetTop<=scrollTop && this.categories[i+1].offsetTop>scrollTop && this.activeCategory != i) {
						this.activeCategory = i
						
						// const scrollLeft = document.querySelector('.top-pannel').scrollLeft
						// const offsetLeft = document.querySelectorAll('.tp-item')[i].offsetLeft
						// const offsetWidth = document.querySelectorAll('.tp-item')[i].offsetWidth
						// const documentWidth = document.documentElement.offsetWidth
						// if((offsetLeft-scrollLeft>documentWidth-offsetWidth-100)||scrollLeft-offsetLeft-offsetWidth>0) {
						// 	smoothscroll.polyfill()
						// 	window.__forceSmoothScrollPolyfill__ = true;
						// 	document.querySelector('.top-pannel').scrollTo({
						// 		left: document.querySelectorAll('.tp-item')[i-1].offsetLeft,
						// 		behavior: "smooth"
						// 	})
						// }
						
						// if(scrollLeft-offsetLeft-offsetWidth>0) {
						// 	document.querySelector('.top-pannel').scrollTo({
						// 		left: document.querySelectorAll('.tp-item')[i-1].offsetLeft,
						// 		behavior: "smooth"
						// 	})
						// }
						// console.log('abc',scrollLeft,offsetLeft,offsetWidth)
						break
					}
					
				}
			}, 100, { 'trailing': false });

			addEventListener('scroll', throttled)

			this.loading = true
			axios({
				url: '/cdfb/Index/Tag/tagList',
				method: 'POST',
				data: {
					type: this.type
				}
			}).then(rep => {
				const {code , data, msg} = rep.data
				if(code == 0){
					this.list = data.tagList
					let categories = data.category
					// let categories = data.tagList.map(tag=>tag.category)
					// categories = Array.from(new Set(categories)) 
					// let categories =[
					// 	"推荐功能",
					// 	"交通出行",
					// 	"导医台",
					// 	"教育",
					// 	"环境天气",
					// 	"营商服务",
					// 	"民生保障",
					// 	"生活便利",
					// 	"公共服务",
					// 	"民生服务"
					// ]
					categories = categories.map(c=>{
						let result = {}
						result.title = c
						result.content = data.tagList.filter(v=>v.category==c) 
						return result
					})
					this.categories = categories
					this.$nextTick(()=>{
						const categoriesElement = document.querySelectorAll('.category')
						const wrapperPaddingTop = categoriesElement[0].offsetTop
						document.querySelectorAll('.category').forEach((ele,i)=>{
							// categories[i].offsetTop = ele.offsetTop
							// debugger
							console.log(ele.offsetTop,i,categories[i])
							categories[i].offsetTop = ele.offsetTop - wrapperPaddingTop
						})
					})
				} else{
					console.log(msg)
				}
				this.loading = false
			})
		},
		methods: {
			handleClicked(id) {
				axios({
					url: `/cdfb/Index/Tag/tagClicked.html?tagId=${id}`,
					method: 'GET',
				})
			},
			handleCategoryClick(index) {
				scrollLock = true
				clearTimeout(timeout)
				timeout = setTimeout(()=>{
					scrollLock = false
				},2000)
				this.activeCategory = index
				smoothscroll.polyfill()
				window.__forceSmoothScrollPolyfill__ = true;
				scrollTo({
					top: this.categories[index].offsetTop,
					behavior: "smooth"
				});
				
			}
		}
	}
</script>
<style lang="scss">
.shizheng {
	padding: 3.2rem 1rem;
	// padding-top: 3.2rem;
	background: #F7F7F7;


	.list-title {
		font-size: .74rem;
		font-weight: 600;
		padding-left: .6rem;
		margin-bottom: .5rem;
		color: #3D3D3D;
	}
	.daoyitai-title {
		margin-bottom: .3rem;
	}
	.top-pannel {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background: #F7F7F7;
		padding: .4rem .46rem;
		padding-top: 1rem;
		overflow-x: scroll;
    white-space: nowrap;
		// border-bottom: 1px solid #F1F2F4;
	}
	.tp-item {
		position: relative;
		display: inline-block;
		color: #333;
		font-size: .8rem;
		padding: 0 .5rem;
	}
	.tp-item.active {
		font-size: .9rem;
		font-weight: 700;
	}
	// .tp-item.active::after {
	// 	position: absolute;
	// 	content: '';
	// 	height: .16rem;
	// 	left: .9rem;
	// 	right: .9rem;
	// 	bottom: -.4rem;
	// 	/* width: 100%; */
	// 	background: #4186E6;
	// }
	.item-list{
		display: flex;
		flex-flow: row wrap;
	}
	.category {
		margin-bottom: .5rem;
		background: #fff;
		border-radius: .5rem;
		padding: .9rem .3rem;
		padding-bottom: 0;
	}
	.daoyitai-catagory {
		padding: 0.9rem 0.4rem;
		padding-bottom: 1rem;
	}
	.item{
		width: 25%;
		text-align: center;
		margin-bottom: .9rem;
	}
	.item a{
		text-align: center;
		display: flex;
		flex-flow: column;
		align-items: center;
	}
	.logo{
		width: 2.2rem;
    height: 2.2rem;
		// border-radius: 100%;
		/* border: 1px solid #F1F2F4; */
		margin-bottom: .4rem;
	}
	.name{
		width: 4rem;
    font-size: .5rem;
		color: #333;
		// overflow: hidden;
		// white-space: nowrap;
		// text-overflow: ellipsis;
	}

	.daoyitai {
		.item-wrapper {
			padding: .32rem;
			width: 33.3%;
			box-sizing: border-box;
			border-radius: 6px;
			// margin-bottom: .2rem
		}
		.item {
			background: #F7F7F7;
			width: 100%;
			height: 5.5rem;
			margin-bottom: 0;
			padding-top: 0.3rem;
			box-sizing: border-box;
			box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.09);
		}
		
	}

}

</style>